<template lang="pug">
.execution-environment(
	:class="[environmentClass, { 'compressed-view': compressedView }]"
)
	.environment-border
		TheNavbar
		#content
			.row
				router-view
				vue-progress-bar#progress-bar
		TheWindowDialog
		TheEnvironmentIndicator
</template>

<script>
import { mapGetters } from "vuex";

import { ACTIVITY_UPDATE_INTERVAL } from "@/env";

import { isActive } from "@/js/network/socket";

import TheNavbar from "@/components/single/TheNavbar/TheNavbar.vue";
import TheWindowDialog from "@/components/single/TheWindowDialog.vue";
import TheEnvironmentIndicator from "@/components/single/TheEnvironmentIndicator.vue";

const activityListeners = ["mousemove", "keydown"];

export default {
	name: "App",
	components: {
		TheNavbar,
		TheWindowDialog,
		TheEnvironmentIndicator
	},
	computed: {
		environmentClass() {
			return this.environment.toLowerCase();
		},
		compressedView() {
			return this.getSetting("compressedView");
		},
		...mapGetters({
			environment: "environment/environment",
			unmigratedSystems: "migratedAssets/unmigratedSystems",
			getSetting: "settings/find"
		})
	},
	created() {
		this.$bus.on("exception", this.onException);
		this.registerActivityListeners();
	},
	beforeUnmount() {
		this.$bus.off("exception", this.onException);
	},
	methods: {
		onException(message) {
			this.$notify.internalError(message);
		},
		registerActivityListeners() {
			activityListeners.forEach((listener) =>
				window.addEventListener(listener, this.handleActivity)
			);
		},
		handleActivity() {
			activityListeners.forEach((listener) =>
				window.removeEventListener(listener, this.handleActivity)
			);
			isActive();
			setTimeout(
				this.registerActivityListeners,
				1000 * ACTIVITY_UPDATE_INTERVAL
			);
		}
	}
};
</script>

<style lang="scss">
@use "@kongsberg-satellite-services/kcl" as kcl-package;

@use "@/assets/scss/variables";
@use "@/assets/scss/box";
@use "@/assets/scss/grid";
@use "@/assets/scss/typography";
@use "@/assets/scss/forms";
@use "@/assets/scss/buttons";
@use "@/assets/scss/tables";
@use "@/assets/scss/notify";
@use "@/assets/scss/datetime";
@use "@/assets/scss/chart";
@use "@/assets/scss/icons";
@use "@/assets/scss/components";
@use "@/assets/scss/kcl" as kcl-overrides;

html,
body {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	box-sizing: border-box;
	font-family: var(--font-family);
	font-weight: var(--font-normal);
	color: var(--body-color);
	font-size: 100%;
	background: var(--body-background);
	margin: 0;
	overflow-anchor: none;

	@include scrollbars(0.5rem, hsl(var(--white20)));
}

*,
*:before,
*:after {
	box-sizing: inherit;
}

#content {
	padding: var(--navbar-visible-height) rem-calc(20 20);

	@media (min-width: $mobile-breakpoint) {
		padding: calc(
				var(--navbar-visible-height) + (var(--standard-padding-height) * 2)
			)
			rem-calc(40 40);
	}
}

.environment-border {
	min-height: 100vh;
	box-sizing: border-box;

	.development &,
	.dev & {
		border: 4px solid hsl(var(--dev-color));
	}

	.test & {
		border: 4px solid hsl(var(--test-color));
	}

	.staging &,
	.preprod & {
		border: 4px solid hsl(var(--staging-color));
	}
}
</style>
